import { useQuery } from '@tanstack/react-query';
import { fetchFeaturedResources, fetchFavoritedResources, type FeaturedResource } from '../api/resourcesApi';

/**
 * React Query hook to fetch and manage featured resources data
 *
 * @returns Query result with featured resources data, loading state, and error state
 */
export function useFeaturedResources() {
  return useQuery<FeaturedResource[], Error>({
    queryKey: ['resources', 'featured'],
    queryFn: fetchFeaturedResources,
    staleTime: 1000 * 60 * 10, // 10 minutes - resources change less frequently
    refetchOnWindowFocus: false, // No need to refetch on focus for static content
  });
}

/**
 * React Query hook to fetch and manage favorited resources data
 *
 * @returns Query result with favorited resources data, loading state, and error state
 */
export function useFavoritedResources() {
  return useQuery<FeaturedResource[], Error>({
    queryKey: ['advisor', 'resources', 'favorited'],
    queryFn: fetchFavoritedResources,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true, // Refetch on focus to stay in sync with favorites
  });
}

